import { render, staticRenderFns } from "./RightChart2.vue?vue&type=template&id=f36f376a&"
import script from "./RightChart2.vue?vue&type=script&lang=js&"
export * from "./RightChart2.vue?vue&type=script&lang=js&"
import style0 from "./RightChart2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports